/* collection-scroll.js — v7 (mobile fixes for fixed elements)
   Works with Shopify collection → product → back and infinite scroll.
   Handles interference from fixed position elements.
*/

/* ————————— global Safari quirk ————————— */
if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

(function () {
  if (!location.pathname.startsWith('/collections/')) return;

  const KEY  = 'collection-scroll';
  const page = location.pathname + location.search;
  const TTL  = 30 * 60 * 1e3;                // 30 min

  /* ---------- save helpers ---------- */
  function save() {
    if (scrollY < 10) return;                // ignore near-top
    
    // Handle body position:fixed (from AI budtender or other modals)
    let actualScrollY = scrollY;
    if (document.body.style.position === 'fixed') {
      // Get actual scroll from body's top offset
      const bodyTop = parseInt(document.body.style.top || '0');
      actualScrollY = Math.abs(bodyTop);
    }
    
    sessionStorage.setItem(
      KEY,
      JSON.stringify({ page, y: actualScrollY, t: Date.now() })
    );
  }

  /* click on any link inside a product card */
  document.addEventListener('click', e => {
    const link = e.target.closest('a');
    if (link && (link.closest('.card-wrapper') || link.href.includes('/products/'))) {
      save();
    }
  });

  /* guaranteed iOS signal that the doc is going away */
  addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') save();
  });
  addEventListener('pagehide',    save);     // BF-cache (iOS/desktop)
  addEventListener('beforeunload', save);    // desktops

  /* ---------- restore after DOM ready ---------- */
  function tryRestore() {
    try {
      const raw = sessionStorage.getItem(KEY);
      if (!raw) return;
      const { page: p, y, t } = JSON.parse(raw);
      if (p !== page || Date.now() - t > TTL) return;
      
      // Wait for any fixed elements to initialize
      requestAnimationFrame(() => {
        // Check if body has position:fixed (modal open)
        if (document.body.style.position === 'fixed') {
          // Store for when modal closes
          window._pendingScrollRestore = y;
          return;
        }
        
        // Restore scroll, accounting for any sticky headers
        const stickyHeader = document.querySelector('.header-wrapper');
        const headerHeight = stickyHeader ? stickyHeader.offsetHeight : 0;
        
        // Use smooth scroll for better mobile experience
        window.scrollTo({
          top: y,
          behavior: 'instant'
        });
      });
    } catch (_) {}
  }

  document.addEventListener('DOMContentLoaded', tryRestore);
  addEventListener('pageshow', tryRestore);  // BF-cache return
  
  // Watch for body position changes (modal close)
  const bodyObserver = new MutationObserver(() => {
    if (document.body.style.position !== 'fixed' && window._pendingScrollRestore) {
      const y = window._pendingScrollRestore;
      delete window._pendingScrollRestore;
      setTimeout(() => scrollTo(0, y), 50);
    }
  });
  
  bodyObserver.observe(document.body, {
    attributes: true,
    attributeFilter: ['style']
  });
})();